module.exports = __webpack_public_path__ + "static/img/ic_kindgarden_on@2x.95b72bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_kindgarden_on@2x.png
// module id = gxDn
// module chunks = 1